import React from 'react'
import PropTypes from 'prop-types'
import {
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import FileDownloadOutlinedIcon from 'components/material-symbol/icons/FileDownload'
import { CSVLink } from 'react-csv'
import { generateStudentListCsvData } from './utils'
import Dialog from 'components/dialog'

const useStyles = makeStyles(theme => ({
  titleRoot: {
    padding: theme.spacing(3, 7, 0.5, 3),
  },
  content: {
    padding: theme.spacing(0, 3, 2),
  },
  bodyText: {
    margin: 0,
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
  },
  actions: {
    padding: theme.spacing(2, 3, 3),
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
  },
}))

const ExportStudentListDialog = ({ open, setOpen, students }) => {
  const classes = useStyles()

  const handleClose = () => setOpen(false)

  return (
    <Dialog
      isOpen={open}
      onClose={handleClose}
      showCloseButton
      fullWidth
      maxWidth="xs"
    >
      {() => (
        <>
          <DialogTitle classes={{ root: classes.titleRoot }}>
            Export student list
          </DialogTitle>
          <DialogContent classes={{ root: classes.content }}>
            <Typography className={classes.bodyText}>
              Export your full student list as a CSV file. Click Download to
              save it to your device.
            </Typography>
          </DialogContent>
          <DialogActions className={classes.actions}>
            <Button color="primary" size="large" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              component={CSVLink}
              variant="contained"
              color="primary"
              size="large"
              disableElevation
              startIcon={<FileDownloadOutlinedIcon fontSize="small" />}
              filename="student_list.csv"
              data={generateStudentListCsvData(students)}
              onClick={handleClose}
            >
              Download
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

ExportStudentListDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  students: PropTypes.array,
}

export default ExportStudentListDialog
